export default __webpack_public_path__ + "locales/pl/WebPlugins.json?hash=bfd597015e9a582c279260695ca512c3";